export const GET_ALL_QUEUES = 'GET_ALL_QUEUES'
export const GET_SPECIFIC_QUEUE = 'GET_SPECIFIC_QUEUE'
export const GET_QUEUE_USE = 'GET_QUEUE_USE'
export const GET_ALL_AUDIOS = 'GET_ALL_AUDIOS'
export const GET_ALL_WAIT_MUSIC = 'GET_ALL_WAIT_MUSIC'
